import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import {CardPerso} from '@gull'

const JournalVenteConfigMain = (props) => {
    const t = useTranslate();
    const [disabledValidate,setDisabledValidate] = useState(false)
    const [validButton,setValidButton] = useState(false)
    const [inputMainValue,setInputMainValue] = useState({//useState qui gère le code, nb section et le chiffre à incrémenter
        code:'',
        ventilationCompta:'',
    })
    let listVentitlationChoice = ['taxe','commerce','caisse','mode_paiement',]

    const handleChange = (e,inputName) => {
        setInputMainValue({...inputMainValue,[inputName]:e.target.value})
    };

    return(
        <>
            <CardPerso header={<span className='d-flex justify-content-between'>
                <span>{(props.isFor=='b2c') ? t('salesJournalConfigurationB2c') : t('salesJournalConfigurationB2b')}</span>
                <button 
                    disabled={disabledValidate || validButton} 
                    className='btn btn-primary' 
                    // onClick={()=>handleSubmitConf()}
                >
                    {validButton ? <div className="spinner-border spinner-border-sm"></div> : t('btnValidate')}
                </button>
            </span>}>
                <div className="row mb-1">
                    <div className="col-12 col-md-4 form-group">
                        <label>{t('salesJournalCode')}</label> 
                        <input disabled={validButton} value={inputMainValue.code} type="text" className='form-control' onChange={(e)=>handleChange(e,'code')}/>
                    </div>
                    <div className="col-12 col-md-8 form-group">
                        <label>{t('numberOfSection')}</label> 
                        <input disabled={validButton} value={inputMainValue.ventilationCompta} type="number" className='form-control' onChange={(e)=>handleChange(e,'ventilationCompta')}/>
                    </div>
                </div>
            </CardPerso>
            {/* {(inputMainValue.nbrSection!='' && Object.keys(sectionCorrespondenceValue).lenght!=0) &&
                <CodeSectionForm 
                    nbrSection={inputMainValue.nbrSection}
                    sectionFieldValue={sectionFieldValue}
                    setSectionFieldValue={setSectionFieldValue}

                    sectionCorrespondenceValue={sectionCorrespondenceValue}
                    setSectionCorrespondenceValue={setSectionCorrespondenceValue}
                    datas={props.datas}
                    isFor={props.isFor}
                    allClientType={props.allClientType}
                    validButton={validButton}
                />
            } */}
        </>
    )
}

export default JournalVenteConfigMain;